export default function () {

  //自身の位置までウィンドウスクロールされると、クラスを追加

  $el = $('.js-scroll-point');

  function setPos() {
    $el.each(function () {
      $(this).data({
        'top': $(this).offset().top - $(window).height() * .6
      });
    });
  }

  function init() {
    $el.each(function () {
      if ( $(this).offset().top <= $(window).height() ) {
        $(this).addClass('is-fire');
      }
    });
  }

  $(window).on('resize', setPos);

  $(window).on('scroll', function () {
    let scTop = $(window).scrollTop();

    $el.each(function () {
      if (scTop >= $(this).data('top')) {
        $(this).addClass('is-fire');
      }
    });

  });

  $(window).trigger('scroll');
  setPos();
  init();

  $('.scroll-efct-line').each(function(i, v) {
    $(this).find('.scroll-efct-line__item').each(function(i2, v2) {
      $(this).css( {'transition-delay': (i2*.3)+'s'} );
    });
  });

}
